import { CustomerItem, CustomerListResponse } from "../types"

interface QueryParams {
  limit?: number
  offset?: number
  fields?: string
  q?: string
  // Add other query parameters as needed
}

class Customer {
  private client: unknown

  /**
   * @ignore
   */
  constructor(client: unknown) {
    this.client = client
  }

  async list(
    queryParams?: QueryParams,
    headers?: Record<string, string>
  ): Promise<CustomerListResponse> {
    return (this.client as any).fetch(`/admin/p_customers`, {
      headers,
      query: queryParams,
    })
  }

  create(
    body: any,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<any> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/p_customers`, {
        method: "POST",
        headers,
        body,
        query,
      })
    })()
  }

  update(
    id: string,
    body: any,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<any> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/p_customers/${id}`, {
        method: "PUT",
        headers,
        body,
        query,
      })
    })()
  }

  retrieve(
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<{ data: CustomerItem }> {
    return (async () => {
      const { id, vendorId, ...rest } = queryParams as any
      return await (this.client as any).fetch(
        vendorId
          ? `/vendor/${vendorId}/customer/${id}`
          : `/admin/p_customers/${id}`,
        {
          query: rest,
          headers,
        }
      )
    })()
  }

  delete(id: string, headers?: Record<string, unknown>): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/p_customers/${id}`, {
        method: "DELETE",
        headers,
      })
    })()
  }

  addCustomer(
    body: { customerIds: string[]; userIds: string[] },
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<any> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/customer-user/add-user`, {
        method: "POST",
        headers,
        body,
        query,
      })
    })()
  }

  removeCustomer(
    body: { customerIds: string[]; userIds: string[] },
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<any> {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/customer-user/remove-user`,
        {
          method: "POST",
          headers,
          body,
          query,
        }
      )
    })()
  }

  retrieveVendorCustomer(
    id: string,
    body?: { vendorId?: string; customerIds?: string[] },
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<any> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/vendor-customer/${id}`, {
        method: "GET",
        headers,
        body,
        query,
      })
    })()
  }

  updateVendorCustomerRelationships(
    pcustomerId: string,
    body: {
      relationships: Array<{
        vendor_id: string
        pcustomer_id: string
        ref_id: string | null
        ref_parent_id: string | null
      }>
    },
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<any> {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/vendor-customer/${pcustomerId}`,
        {
          method: "POST",
          headers,
          body,
          query,
        }
      )
    })()
  }
}

export { Customer }
